interface FieldCloseProps {
    color?: string;
    className?: string;
}

function FieldClose({ color = 'currentColor', className = null }: FieldCloseProps) {
    return (
        <svg
            width="9"
            height="8"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path d="M8 7.5L1 0.499999" stroke={color} strokeLinecap="round" />
            <path d="M8 0.5L1 7.5" stroke={color} strokeLinecap="round" />
        </svg>
    );
}

export default FieldClose;
